angular.module("igsSolarOps")
  .directive("decimalPrecision", function () {
    return {
      restrict: "A",
      link: function (scope, element, attr) {
        element.on("input", function (e) {
          var maxDecimal = Number(element.attr("decimal-precision"));
          var sal = element.val();
          var parts;
          if (sal.indexOf(".") !== -1) {
            parts = sal.split(".");
            if (parts[1].length > maxDecimal) {
              element.val(sal.substr(0, sal.length - 1));
            }
          }
        });


        scope.$on("$destroy", function () {
          element.off("input");
        });
      }
    }
  });
